import { render } from "./gameEvents.vue?vue&type=template&id=77433b54"
import script from "./gameEvents.vue?vue&type=script&lang=js"
export * from "./gameEvents.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__